// Datawrapper: one resize listener, lazy + staggered iframe loading
(function () {
    const HOST = 'datawrapper.dwcdn.net';
    const BATCH_SIZE = 2;
    const BATCH_GAP_MS = 300;
    const ROOT_MARGIN = '400px 0px';

    if (!window.__cfrDatawrapperInit) {
        window.__cfrDatawrapperInit = true;

        window.addEventListener('message', (event) => {
            const heights = event.data && event.data['datawrapper-height'];
            if (!heights) {
                return;
            }

            const iframes = document.querySelectorAll('iframe');

            for (const key in heights) {
                if (!Object.prototype.hasOwnProperty.call(heights, key)) {
                    continue;
                }

                for (let i = 0; i < iframes.length; i++) {
                    const iframe = iframes[i];
                    if (iframe.contentWindow === event.source) {
                        iframe.style.height = heights[key] + 'px';
                    }
                }
            }
        });
    }

    function removeDuplicateEmbedScripts() {
        document.querySelectorAll('.data__source script').forEach((script) => {
            if (script.textContent.includes('datawrapper-height')) {
                script.remove();
            }
        });
    }

    function reserveEmbedSpace(iframe) {
        const container = iframe.closest('.data__source');
        const height = parseInt(iframe.getAttribute('height'), 10);

        if (container && height > 0) {
            container.style.minHeight = height + 'px';
            container.classList.add('data__source--pending');
        }
    }

    function collectPendingIframes() {
        const iframes = document.querySelectorAll(`iframe[data-src*="${HOST}"]`);

        iframes.forEach((iframe) => {
            if (!iframe.dataset.dwPrepared) {
                iframe.dataset.dwPrepared = '1';
                reserveEmbedSpace(iframe);
            }
        });

        return Array.from(iframes).filter((iframe) => !iframe.dataset.dwLoaded);
    }

    const queue = [];
    let active = 0;

    function loadIframe(iframe, onDone) {
        const src = iframe.getAttribute('data-src');

        if (!src || iframe.dataset.dwLoaded) {
            onDone();
            return;
        }

        iframe.dataset.dwLoaded = '1';
        iframe.classList.remove('datawrapper-embed--pending');
        iframe.classList.add('datawrapper-embed--loading');
        iframe.setAttribute('src', src);

        const finish = () => {
            iframe.classList.remove('datawrapper-embed--loading');
            const container = iframe.closest('.data__source');
            if (container) {
                container.classList.remove('data__source--pending');
            }
            onDone();
        };

        iframe.addEventListener('load', finish, { once: true });
        iframe.addEventListener('error', finish, { once: true });
    }

    function pumpQueue() {
        while (active < BATCH_SIZE && queue.length) {
            const iframe = queue.shift();
            active++;
            loadIframe(iframe, () => {
                active--;
                setTimeout(pumpQueue, BATCH_GAP_MS);
            });
        }
    }

    function enqueue(iframe) {
        if (iframe.dataset.dwQueued) {
            return;
        }

        iframe.dataset.dwQueued = '1';
        queue.push(iframe);
        pumpQueue();
    }

    function initDatawrapperEmbeds() {
        removeDuplicateEmbedScripts();

        const iframes = collectPendingIframes();

        if (!iframes.length) {
            return;
        }

        if (!('IntersectionObserver' in window)) {
            iframes.forEach((iframe) => enqueue(iframe));
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    enqueue(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: ROOT_MARGIN, threshold: 0 });

        iframes.forEach((iframe) => observer.observe(iframe));
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDatawrapperEmbeds);
    } else {
        initDatawrapperEmbeds();
    }
})();

// FAQs across the website
if (document.querySelector('.faq')) {
    const faqs = document.querySelectorAll('.faq')
    for (let i = 0; i < faqs.length; i++) {
        faqs[i].addEventListener('click', function (e) {
            this.classList.toggle('faq--active')
        })
    }
}

// When the visitor scrolls 100px from top, show button
window.addEventListener('scroll', function(){
  const footerSticky = document.querySelector('.footer__sticky');
  if (footerSticky) {
    footerSticky.classList.toggle('--change', window.scrollY > 100);
  }
});
